import { rivers } from './contentRivers'
import { titleLabels } from './filterLabels'

export default {
  [rivers.MY_REPORTS]: () => ({
    title: 'Your Reports',
    viewCount: false,
    showMedicalAbstractsToggle: false,
    hideFilterSections: ['type', 'publication_date', 'publication_date_end']
  }),
  [rivers.RELATED_NEWS]: () => ({
    title: 'Related News',
    hideFilterSections: ['type', 'publication_date', 'publication_date_end'],
    viewCount: false,
    showMedicalAbstractsToggle: false
  }),
  [rivers.RELATED_ANALYSIS]: () => ({
    title: 'Related Analysis',
    hideFilterSections: ['type', 'publication_date', 'publication_date_end'],
    viewCount: false,
    showMedicalAbstractsToggle: false
  }),
  [rivers.ALL_REPORTS]: () => ({
    title: 'All Reports',
    hideFilterSections: ['type', 'publication_date', 'publication_date_end'],
    viewCount: false,
    showMedicalAbstractsToggle: false
  }),
  [rivers.TAG]: ({ args = '' } = {}) => {
    const regex = /^(\w+)\/(.*)$/
    const match = regex.exec(args)
    const [, , tag] = match === null ? [null, null, args] : match
    return {
      title: tag + ' Reports',
      excludeFilterValues: [tag],
      viewCount: false,
      includeRelatedTags: true,
      showMedicalAbstractsToggle: false,
      hideFilterSections: ['type', 'publication_date', 'publication_date_end']
    }
  },
  [rivers.ALL_BY]: ({ args = '' } = {}) => {
    const regex = /^(\w+)\/(.*)$/
    const match = regex.exec(args)
    const [, , value] = match === null ? [null, null, args] : match
    const titleMapped = titleLabels[value]
    return {
      title: 'All ' + titleMapped + ' Reports',
      viewCount: false,
      showMedicalAbstractsToggle: false,
      hideFilterSections: ['type', 'publication_date', 'publication_date_end']
    }
  },
  [rivers.OTHER_BY]: ({ args = '' } = {}) => {
    const regex = /^(\w+)\/(.*)$/
    const match = regex.exec(args)
    const [, , value] = match === null ? [null, null, args] : match
    const titleMapped = titleLabels[value]
    return {
      title: 'Other ' + titleMapped + ' Reports',
      viewCount: false,
      showMedicalAbstractsToggle: false,
      hideFilterSections: ['type', 'publication_date', 'publication_date_end']
    }
  },
  [rivers.TYPE]: ({ args = '' } = {}) => {
    return {
      title: args,
      excludeFilterValues: [args],
      viewCount: false,
      showMedicalAbstractsToggle: false,
      hideFilterSections: ['type', 'publication_date', 'publication_date_end']
    }
  },
  [rivers.UPCOMING_REPORTS]: () => ({
    title: 'Upcoming Reports',
    viewCount: false,
    showMedicalAbstractsToggle: false,
    hideFilterSections: ['type', 'publication_date', 'publication_date_end']
  }),
  [rivers.SEARCH]: () => ({
    title: 'Search Results',
    viewCount: false,
    cancelLoadRiver: true,
    showMedicalAbstractsToggle: false,
    showFeaturedContent: false,
    getFeaturedContentTag: false,
    hideFilterSections: ['type', 'publication_date', 'publication_date_end']
  }),
  [rivers.LIBRARY_PICKS]: () => ({
    title: 'Library Picks',
    hideFilterSections: ['type'],
    viewCount: false,
    showMedicalAbstractsToggle: false,
    showSingleFeaturedContent: false
  }),
  [rivers.DEFAULT_RIVER]: () => ({
    title: 'search',
    viewCount: false,
    cancelLoadRiver: true,
    showMedicalAbstractsToggle: false,
    hideFilterSections: ['type', 'publication_date', 'publication_date_end']
  })
}
